import AppConfig from '../common/AppConfig';
import './EnvironmentBanner.css';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const bannerConfig = {
  Local: { label: 'Local Environment', className: 'env-banner env-banner--local' },
  QA: { label: 'QA Environment', className: 'env-banner env-banner--qa' },
  PreProd: { label: 'Pre-Production Environment', className: 'env-banner env-banner--preprod ' },
}

const IsScheduleActive = (n) => {
  const now = new Date();

  // null start = no lower bound; null end = no upper bound
  const started = !n.startsAt || new Date(n.startsAt) <= now;
  const notEnded = !n.endsAt || new Date(n.endsAt) >= now;

  return started && notEnded;
};

const pathByFormTypeId = {
  3: "/ttchecksocket",
  4: "/tfchecksocket",
  5: "/ttdefinitive",
  6: "/tfdefinitive",
  13: "/kneebundle",
  14: "/liners",
  15: "/feet",
  23: "/designliners",
}

const EnvironmentBanner = (props) => {
  const location = useLocation();
  const pathName = location.pathname;

  const config = bannerConfig[AppConfig.environment];

  const notifications = props.notifications;

  if (!config) return null;

  let dedupedNotifications = [];
  if (notifications && notifications.length > 0) {
    let activeNotifications = notifications.filter(n => n.isActive && IsScheduleActive(n));

    let pageNotifications = activeNotifications.filter(n => {
      return n.notificationPages?.some(p => p.pagePath === pathName);
    });
    pageNotifications = pageNotifications.sort((a, b) => a.priority - b.priority);

    if (props.multiProductCart) {
      const multiProductPaths = (props.multiProductCart ?? "")
        .split(",")
        .map(id => pathByFormTypeId[id.trim()])
        .filter(Boolean); // drop any ids with no mapped path

      let relatedNotifications = activeNotifications.filter(n =>
        n.notificationPages?.some(p => multiProductPaths.includes(p.pagePath))
      );

      if (relatedNotifications.length > 0) {
        relatedNotifications = relatedNotifications.sort((a, b) => a.priority - b.priority);
        pageNotifications = pageNotifications.concat(relatedNotifications);
      }
    }

    pageNotifications.forEach(pn => {
      if (!dedupedNotifications.find(dn => dn.id === pn.id)) {
        dedupedNotifications.push(pn);
      }
    });
  }

  return (
    <>
      <div className={config.className}>
        {config.label}
      </div>
      {dedupedNotifications.map((n) => {
        return (<div key={n.id} className={n.className}>
          {n.message}
        </div>)
      })}
    </>
  );
};

export default EnvironmentBanner;
